"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref, PropSync, Prop } from "vue-property-decorator";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import API from "@ym-framework/api-utils";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import { AccountSessionMixins } from "@/service/account-session";
import AuthPinLogin from "@/app_views/login/components/AuthPinLogin.vue";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import AccountDevice from "@/app_views/login/components/AccountDevice.vue";
import i18n from "@/lang";
import { TimerEngine } from "@/utils/settimeout";
import { LoginService } from "@/service/login";
import { WEB_HTML } from "@/configuration/websocketskey";
let loginService = new LoginService();
class AuthFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.auth_id = "";
    this.password = "";
    this.auth_id_prefix = "+86";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "phonelogin.please_enter_your_mobile_phone_number"
      ),
      trigger: "blur"
    }
  ])
], AuthFormController.prototype, "auth_id", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("phonelogin.please_enter_the_password"),
      trigger: "blur"
    }
  ])
], AuthFormController.prototype, "password", 2);
class CodeFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.phone = "";
    this.code = "";
    this.regionCode = "+86";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("phonelogin.phone_number_could_not_null"),
      trigger: "blur"
    }
  ])
], CodeFormController.prototype, "phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("phonelogin.code_could_not_null"),
      trigger: "blur"
    }
  ])
], CodeFormController.prototype, "code", 2);
let PhoneLogin = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.iconShow = true;
    this.remember = false;
    this.activeTitle = localStorage.getItem("logintabs") || "account";
    this.account = [];
    this.account_mode = "all";
    this.sub_account_mode = "all";
    this.verifyCodeSend = false;
    this.verifyCodeTimer = 90;
    this.accountTitle = "account";
    this.sub_remember = false;
    this.sub_account = [];
    this.authFormController = new AuthFormController();
    this.subAccountauthFormController = new AuthFormController();
    this.codeFormController = new CodeFormController();
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getAccountList();
      yield this.getSubAccountList();
      yield this.getLoginTab();
    });
  }
  checkVisitorId() {
    return __async(this, null, function* () {
      try {
        console.log("\u83B7\u53D6\u8BBF\u5BA2ID \u672A\u5B9E\u73B0");
      } catch (error) {
        console.log(error);
      }
    });
  }
  get lang() {
    let lang = "cn";
    if (this.$i18n.locale === "en-US") {
      lang = "en";
    }
    return lang;
  }
  handleCodeClick() {
    this.activeTitle = "code";
    localStorage.setItem("logintabs", this.activeTitle);
  }
  handleAccountClick() {
    this.activeTitle = "account";
    localStorage.setItem("logintabs", this.activeTitle);
  }
  handletabsClick() {
    if (this.accountTitle === "account") {
      this.inputAccount();
    }
    if (this.accountTitle === "user") {
      this.inputAccount();
    }
    this.$emit("hideFlag", this.accountTitle);
  }
  changeQrCode() {
    this.$emit("changeQrCode", !this.isQrCode);
  }
  toConnectUs() {
    window.open(`https://www.kuajingvs.com/contact`, "_blank");
  }
  // 获取子账号和主账号的账号列表
  //获取上次登录信息 用户密码列表
  getAccountList() {
    return __async(this, null, function* () {
      var _a;
      this.account = [];
      let last_account = false;
      let response = yield loginService.getAllUsedAccountsFromLocal();
      if (response.datas.length !== 1 && !((_a = response.last_account) == null ? void 0 : _a.account)) {
        response.last_account = response.datas[0];
      }
      let accounts = response.datas;
      if (
        // 上一次所登陆的密码
        response.hasOwnProperty("last_account") && response.last_account && response.last_account.account !== ""
      ) {
        last_account = true;
        this.authFormController.auth_id = response.last_account.account;
        if (response.last_account.remember) {
          this.authFormController.password = response.last_account.password;
        }
        this.remember = response.last_account.remember;
      }
      for (let account of accounts) {
        this.account.push(account);
        if (this.authFormController.auth_id === "" && !last_account) {
          this.authFormController.auth_id = account.account;
          this.authFormController.password = account.password;
          this.remember = account.remember;
        }
      }
    });
  }
  getSubAccountList() {
    return __async(this, null, function* () {
      var _a;
      this.sub_account = [];
      let last_sub_account = false;
      let response = yield loginService.getAllUsedSubAccountsFromLocal();
      if (response.datas.length !== 1 && !((_a = response.last_account) == null ? void 0 : _a.account)) {
        response.last_account = response.datas[0];
      }
      let accounts = response.datas;
      if (
        // 上一次所登陆的密码
        response.hasOwnProperty("last_account") && response.last_account && response.last_account.account !== ""
      ) {
        last_sub_account = true;
        this.subAccountauthFormController.auth_id = response.last_account.account;
        if (response.last_account.remember) {
          this.subAccountauthFormController.password = response.last_account.password;
        }
        this.sub_remember = response.last_account.remember;
      }
      for (let account of accounts) {
        this.sub_account.push(account);
        if (this.subAccountauthFormController.auth_id === "" && !last_sub_account) {
          this.subAccountauthFormController.auth_id = account.account;
          this.subAccountauthFormController.password = account.password;
          this.sub_remember = account.remember;
        }
      }
    });
  }
  authSubmit(data) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      if (this.authFormController.auth_id.length > 11) {
        this.$message.error(this.$t("phonelogin.form_auth_id.wrong_account"));
        this.authFormController.complete();
        return;
      }
      try {
        let device = yield DeviceFormatter.getInfo();
        let _visitor_id = "";
        if (this.$matomo) {
          _visitor_id = this.$matomo.getVisitorId();
        }
        const response = yield API.post("api://base.login/v1/auth", {
          model: "account.password",
          account: this.authFormController.auth_id,
          //"13672021479"
          accountPrefix: this.authFormController.auth_id_prefix,
          password: this.authFormController.password,
          deviceCode: device.device_mini,
          deviceName: device.device_name,
          deviceInfo: device.device_info,
          allowLogin: false,
          platform: "pc",
          loginType: "LOGIN_ACCOUNT"
        });
        if (response.data.model === "account.pinverify") {
          let data2 = {
            model: "pin.verify",
            remember_password: this.remember,
            token: response.data.token,
            account: this.authFormController.auth_id,
            password: this.authFormController.password
          };
          yield this._auth_pin.open(data2, "form");
          return;
        }
        if (response.data.model === "device.auth") {
          yield this._account_device.open(response.data, "form");
          return;
        }
        try {
          const serviceCodeResponse = yield API.get(`api://base.local/storages/session/deviceToken`);
          const serviceToken = serviceCodeResponse.data.value.deviceToken;
          const device_bind_response = yield API.get(`api://base.auth.message/v1/check/user-devices`, {
            params: {
              "deviceId": serviceToken
            },
            headers: {
              "Authorization": response.data.token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
            }
          });
          if (device_bind_response.data.bindDevice === true) {
            yield this.$confirm(
              `${this.$t("phonelogin.device_online_tip_content")}<br/>${this.$t("phonelogin.device_online_tip_sub_account")}<a
               href="https://www.kuajingvs.com/help2/7048"
               target="_blank"
               style="text-decoration: none; color: #1DCF6A"
            >${this.$t("phonelogin.device_online_tip_sub_account_link")}</a>`,
              this.$t("vdbindshop.binding_shop_confirm_title"),
              {
                roundButton: true,
                dangerouslyUseHTMLString: true,
                cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`,
                closeOnClickModal: false
              }
            );
          }
        } catch (error) {
          console.log(error);
          if (error === "cancel") {
            return;
          }
        }
        const token_response = yield API.post(
          `api://base.login/v1/auth-temporary-token`,
          {},
          {
            headers: {
              "x-auth-token": response.data.token,
              "Accept-Language": (_b = localStorage.getItem("lang")) != null ? _b : "zh-CN"
            }
          }
        );
        if (token_response.data.marks !== null && token_response.data.marks.tags.includes("TEAM_JOIN_ALERT")) {
          localStorage.setItem("showJoinTeamMessage", "true");
        }
        loginService.setTokenToLocal(token_response.data.token);
        yield this.saveAccount(
          this.authFormController.auth_id,
          this.remember ? this.authFormController.password : ""
        );
        yield this.saveLoginTab();
        try {
          let version = yield API.get(`api://base.local/update/version`);
          let _version = version.data.version;
          let _session = yield API.get(`api://base.auth.pro/v1/account/session`, {
            headers: {
              "Authorization": token_response.data.token,
              "Accept-Language": (_c = localStorage.getItem("lang")) != null ? _c : "zh-CN"
            }
          });
          const session = _session.data;
          yield loginService.setSessionToLocal(session);
          yield API.post(`api://base.local/websockets/main`, {
            model: "pageEvent.login.success",
            value: {
              message: "login_success",
              session: _session.data
            }
          });
          yield API.post(`api://base.local/websockets/messageservice`, {
            model: "pageEvent.login.success",
            value: {
              message: "login_success",
              session: _session.data
            }
          });
          if (this.$matomo) {
            this.$matomo.setUserId(_session.data.id);
          }
          API.post(`api://base.auth/api/v3/client/logs`, {
            logs: [
              {
                name: "client.login",
                message: "login.success",
                datas: {
                  time: {
                    time: new Date().getTime(),
                    date: new Date()
                  },
                  version: _version,
                  patch: _version,
                  computer: {
                    graphics: device.device_info.detail.graphics,
                    os_arch: device.device_info.os_arch,
                    cpu: device.device_info.detail.cpu,
                    os: device.device_info.detail.osInfo,
                    memory: device.device_info.detail.mem,
                    network: device.device_info.detail.networkInterfaces,
                    time: {
                      date: new Date()
                    }
                  }
                }
              }
            ]
          });
          let flag = false;
          let _activity_data = null;
          try {
            let response2 = yield API.get(
              `api://base.auth/api/v8/activity-popups`,
              {
                params: {
                  scenes: "login"
                }
              }
            );
            _activity_data = JSON.stringify(response2.data);
            flag = true;
          } catch (error) {
            console.dir(error);
          } finally {
            if (flag) {
              let _href = `${WEB_HTML}/?activity=${_activity_data}`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/?activity=${_activity_data}`;
              }
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              if (this._jump !== "" && this._jump !== null) {
                if (this._jump.indexOf("?") !== -1) {
                  _href = `${WEB_HTML}/${this._jump}&activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}&activity=${_activity_data}`;
                  }
                } else {
                  _href = `${WEB_HTML}/${this._jump}?activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}?activity=${_activity_data}`;
                  }
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com/`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              try {
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("gateway.kuajingvs.com") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://gateway.kuajingvs.com/kvapp",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://gateway.kuajingvs.com/kvapp",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                } else {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("api") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://api.kuajingvs.com",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://api.kuajingvs.com",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                }
              } catch (error) {
              }
              window.open(_href, "_self");
            }
            if (!flag) {
              let _href = `${WEB_HTML}/`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/`;
              }
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              if (this._jump !== "" && this._jump !== null) {
                _href = `${WEB_HTML}/${this._jump}`;
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  _href = `https://pre.kuajingvs.com/${this._jump}`;
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              try {
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("gateway.kuajingvs.com") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://gateway.kuajingvs.com/kvapp",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://gateway.kuajingvs.com/kvapp",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                } else {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("api") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://api.kuajingvs.com",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://api.kuajingvs.com",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                }
              } catch (error) {
              }
              window.open(_href, "_self");
            }
          }
        } catch (error) {
          console.dir(error);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error((_d = error.response.data.errors) == null ? void 0 : _d.datas[0].message);
        }
      } finally {
        this.authFormController.complete();
      }
    });
  }
  //子账号登录
  subAccountSubmit(data) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      const phoneRegex = /^[0-9]+$/;
      if (phoneRegex.test(this.subAccountauthFormController.auth_id) && this.subAccountauthFormController.auth_id.length < 13) {
        this.$message.error(this.$t("phonelogin.form_auth_id.wrong_account_tip"));
        this.subAccountauthFormController.complete();
        return;
      }
      let device = yield DeviceFormatter.getInfo();
      try {
        let _visitor_id = "";
        if (this.$matomo) {
          _visitor_id = this.$matomo.getVisitorId();
        }
        const response = yield API.post("api://base.login/v1/auth", {
          model: "account.password",
          account: this.subAccountauthFormController.auth_id,
          password: this.subAccountauthFormController.password,
          deviceCode: device.device_mini,
          deviceName: device.device_name,
          deviceInfo: device.device_info,
          allowLogin: false,
          platform: "pc",
          loginType: "LOGIN_SUB_ACCOUNT"
        });
        if (response.data.model === "account.pinverify") {
          let data2 = {
            model: "pin.verify",
            remember_password: this.sub_remember,
            token: response.data.token,
            account: this.subAccountauthFormController.auth_id,
            password: this.subAccountauthFormController.password
          };
          yield this._auth_pin.open(data2, "form");
          return;
        }
        if (response.data.model === "device.auth") {
          yield this._account_device.open(response.data, "form");
          return;
        }
        try {
          const serviceCodeResponse = yield API.get(`api://base.local/storages/session/deviceToken`);
          const serviceToken = serviceCodeResponse.data.value.deviceToken;
          const device_bind_response = yield API.get(`api://base.auth.message/v1/check/user-devices`, {
            params: {
              "deviceId": serviceToken
            },
            headers: {
              "Authorization": response.data.token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
            }
          });
          if (device_bind_response.data.bindDevice === true) {
            yield this.$confirm(
              `${this.$t("phonelogin.device_online_tip_content")}<br/>${this.$t("phonelogin.device_online_tip_sub_account")}<a
               href="https://www.kuajingvs.com/help2/7048"
               target="_blank"
               style="text-decoration: none; color: #1DCF6A"
            >${this.$t("phonelogin.device_online_tip_sub_account_link")}</a>`,
              this.$t("vdbindshop.binding_shop_confirm_title"),
              {
                roundButton: true,
                dangerouslyUseHTMLString: true,
                cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`,
                closeOnClickModal: false
              }
            );
          }
        } catch (error) {
          console.log(error);
          if (error === "cancel") {
            return;
          }
        }
        const token_response = yield API.post(
          `api://base.login/v1/auth-temporary-token`,
          {},
          {
            headers: {
              "x-auth-token": response.data.token,
              "Accept-Language": (_b = localStorage.getItem("lang")) != null ? _b : "zh-CN"
            }
          }
        );
        if (token_response.data.marks !== null && token_response.data.marks.tags.includes("TEAM_JOIN_ALERT")) {
          localStorage.setItem("showJoinTeamMessage", "true");
        }
        loginService.setTokenToLocal(token_response.data.token);
        yield this.saveSubAccount(
          this.subAccountauthFormController.auth_id,
          this.sub_remember ? this.subAccountauthFormController.password : ""
        );
        yield this.saveLoginTab();
        try {
          let version = yield API.get(`api://base.local/update/version`);
          let _version = version.data.version;
          let _session = yield API.get(`api://base.auth.pro/v1/account/session`, {
            headers: {
              "Authorization": token_response.data.token,
              "Accept-Language": (_c = localStorage.getItem("lang")) != null ? _c : "zh-CN"
            }
          });
          const session = _session.data;
          yield loginService.setSessionToLocal(session);
          yield API.post(`api://base.local/websockets/main`, {
            model: "pageEvent.login.success",
            value: {
              message: "login_success",
              session: _session.data
            }
          });
          yield API.post(`api://base.local/websockets/messageservice`, {
            model: "pageEvent.login.success",
            value: {
              message: "login_success",
              session: _session.data
            }
          });
          if (this.$matomo) {
            this.$matomo.setUserId(_session.data.id);
          }
          API.post(`api://base.auth/api/v3/client/logs`, {
            logs: [
              {
                name: "client.login",
                message: "login.success",
                datas: {
                  time: {
                    time: new Date().getTime(),
                    date: new Date()
                  },
                  version: _version,
                  patch: _version,
                  computer: {
                    graphics: device.device_info.detail.graphics,
                    os_arch: device.device_info.os_arch,
                    cpu: device.device_info.detail.cpu,
                    os: device.device_info.detail.osInfo,
                    memory: device.device_info.detail.mem,
                    network: device.device_info.detail.networkInterfaces,
                    time: {
                      date: new Date()
                    }
                  }
                }
              }
            ]
          });
          let flag = false;
          let _activity_data = null;
          try {
            let response2 = yield API.get(
              `api://base.auth/api/v8/activity-popups`,
              {
                params: {
                  scenes: "login"
                }
              }
            );
            _activity_data = JSON.stringify(response2.data);
            flag = true;
          } catch (error) {
            console.dir(error);
          } finally {
            if (flag) {
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              let _href = `${WEB_HTML}/?activity=${_activity_data}`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/?activity=${_activity_data}`;
              }
              if (this._jump !== "" && this._jump !== null) {
                if (this._jump.indexOf("?") !== -1) {
                  _href = `${WEB_HTML}/${this._jump}&activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}&activity=${_activity_data}`;
                  }
                } else {
                  _href = `${WEB_HTML}/${this._jump}?activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}?activity=${_activity_data}`;
                  }
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              try {
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("gateway.kuajingvs.com") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://gateway.kuajingvs.com/kvapp",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://gateway.kuajingvs.com/kvapp",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                } else {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("api") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://api.kuajingvs.com",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://api.kuajingvs.com",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                }
              } catch (error) {
              }
              window.open(_href, "_self");
            }
            if (!flag) {
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              let _href = `${WEB_HTML}/`;
              if (this._jump !== "" && this._jump !== null) {
                _href = `${WEB_HTML}/${this._jump}`;
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  _href = `https://pre.kuajingvs.com/${this._jump}`;
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              try {
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("gateway.kuajingvs.com") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://gateway.kuajingvs.com/kvapp",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://gateway.kuajingvs.com/kvapp",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                } else {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("api") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://api.kuajingvs.com",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://api.kuajingvs.com",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                }
              } catch (error) {
              }
              window.open(_href, "_self");
            }
          }
        } catch (error) {
          console.dir(error);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error((_d = error.response.data.errors) == null ? void 0 : _d.datas[0].message);
        }
      } finally {
        this.subAccountauthFormController.complete();
      }
    });
  }
  getVerifyCode(time = 90) {
    return __async(this, null, function* () {
      var _a;
      try {
        yield API.post(`api://base.auth/api/v1/verify_code/send`, {
          phone: this.codeFormController.phone,
          code_type: 1
        });
        const _verifyCode = new TimerEngine(() => __async(this, null, function* () {
          this.verifyCodeTimer = this.verifyCodeTimer - 1;
          sessionStorage.setItem(
            "verifyCodeTimer",
            this.verifyCodeTimer.toString()
          );
          if (this.verifyCodeTimer <= 0) {
            _verifyCode.stop();
            this.verifyCodeSend = false;
            this.verifyCodeTimer = 90;
          }
        }), 1e3);
        this.verifyCodeTimer = time;
        this.verifyCodeSend = true;
        _verifyCode.start();
      } catch (error) {
        console.dir(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error((_a = error.response.data.errors) == null ? void 0 : _a.datas[0].message);
        }
      }
    });
  }
  codeSubmit() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      let device = yield DeviceFormatter.getInfo();
      try {
        let response = yield API.post(`api://base.login/v1/auth-verifycode`, {
          model: "verify.code",
          deviceCode: device.device_mini,
          phone: this.codeFormController.phone,
          verifyCode: this.codeFormController.code,
          deviceName: device.device_name,
          allowLogin: false,
          deviceInfo: device.device_info,
          platform: "pc"
        });
        if (response.data.model === "account.pinverify") {
          let data = {
            model: "pin.verify",
            remember_password: false,
            token: response.data.token
          };
          yield this._auth_pin.open(data, "form");
          return;
        }
        if (response.data.model === "device.auth") {
          yield this._account_device.open(response.data, "form");
          return;
        }
        try {
          const serviceCodeResponse = yield API.get(`api://base.local/storages/session/deviceToken`);
          const serviceToken = serviceCodeResponse.data.value.deviceToken;
          const device_bind_response = yield API.get(`api://base.auth.message/v1/check/user-devices`, {
            params: {
              "deviceId": serviceToken
            },
            headers: {
              "Authorization": response.data.token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
            }
          });
          if (device_bind_response.data.bindDevice === true) {
            yield this.$confirm(
              `${this.$t("phonelogin.device_online_tip_content")}<br/>${this.$t("phonelogin.device_online_tip_sub_account")}<a
               href="https://www.kuajingvs.com/help2/7048"
               target="_blank"
               style="text-decoration: none; color: #1DCF6A"
            >${this.$t("phonelogin.device_online_tip_sub_account_link")}</a>`,
              this.$t("vdbindshop.binding_shop_confirm_title"),
              {
                roundButton: true,
                dangerouslyUseHTMLString: true,
                cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`,
                closeOnClickModal: false
              }
            );
          }
        } catch (error) {
          console.log(error);
          if (error === "cancel") {
            return;
          }
        }
        const token_response = yield API.post(
          `api://base.login/v1/auth-temporary-token`,
          {},
          {
            headers: {
              "x-auth-token": response.data.token,
              "Accept-Language": (_b = localStorage.getItem("lang")) != null ? _b : "zh-CN"
            }
          }
        );
        if (token_response.data.marks !== null && token_response.data.marks.tags.includes("TEAM_JOIN_ALERT")) {
          localStorage.setItem("showJoinTeamMessage", "true");
        }
        loginService.setTokenToLocal(token_response.data.token);
        let _session = yield API.get(`api://base.auth.pro/v1/account/session`, {
          headers: {
            "Authorization": token_response.data.token,
            "Accept-Language": (_c = localStorage.getItem("lang")) != null ? _c : "zh-CN"
          }
        });
        const session = _session.data;
        yield loginService.setSessionToLocal(session);
        yield API.post(`api://base.local/websockets/main`, {
          model: "pageEvent.login.success",
          value: {
            message: "login_success",
            session: _session.data
          }
        });
        try {
          let version = yield API.get(`api://base.local/update/version`);
          let _version = version.data.version;
          API.post(`api://base.auth/api/v3/client/logs`, {
            logs: [
              {
                name: "client.login",
                message: "login.success",
                datas: {
                  time: {
                    time: new Date().getTime(),
                    date: new Date()
                  },
                  version: _version,
                  patch: _version,
                  computer: {
                    graphics: device.device_info.detail.graphics,
                    os_arch: device.device_info.os_arch,
                    cpu: device.device_info.detail.cpu,
                    os: device.device_info.detail.osInfo,
                    memory: device.device_info.detail.mem,
                    network: device.device_info.detail.networkInterfaces,
                    time: {
                      date: new Date()
                    }
                  }
                }
              }
            ]
          });
          let flag = false;
          let _activity_data = null;
          try {
            let response2 = yield API.get(
              `api://base.auth/api/v8/activity-popups`,
              {
                params: {
                  scenes: "login"
                }
              }
            );
            _activity_data = JSON.stringify(response2.data);
            flag = true;
          } catch (error) {
            console.dir(error);
          } finally {
            if (flag) {
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              let _href = `${WEB_HTML}/?activity=${_activity_data}`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/?activity=${_activity_data}`;
              }
              if (this._jump !== "" && this._jump !== null) {
                if (this._jump.indexOf("?") !== -1) {
                  _href = `${WEB_HTML}/${this._jump}&activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}&activity=${_activity_data}`;
                  }
                } else {
                  _href = `${WEB_HTML}/${this._jump}?activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}?activity=${_activity_data}`;
                  }
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              try {
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("gateway.kuajingvs.com") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://gateway.kuajingvs.com/kvapp",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://gateway.kuajingvs.com/kvapp",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                } else {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("api") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://api.kuajingvs.com",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://api.kuajingvs.com",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                }
              } catch (error) {
              }
              window.open(_href, "_self");
            }
            if (!flag) {
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              let _href = `${WEB_HTML}/`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/`;
              }
              if (this._jump !== "" && this._jump !== null) {
                _href = `${WEB_HTML}/${this._jump}`;
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  _href = `https://pre.kuajingvs.com/${this._jump}`;
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              try {
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("gateway.kuajingvs.com") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://gateway.kuajingvs.com/kvapp",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://gateway.kuajingvs.com/kvapp",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                } else {
                  try {
                    let response2 = yield API.get(`api://base.local/storages/preference/ping_url`);
                    let result = response2.data.value.value;
                    if (result.api_url.indexOf("api") === -1) {
                      yield API.put(`api://base.local/storages/preference/ping_url`, {
                        value: {
                          api_url: "https://api.kuajingvs.com",
                          gateway_url: "https://gateway.kuajingvs.com"
                        }
                      });
                    }
                  } catch (error) {
                    yield API.put(`api://base.local/storages/preference/ping_url`, {
                      value: {
                        api_url: "https://api.kuajingvs.com",
                        gateway_url: "https://gateway.kuajingvs.com"
                      }
                    });
                  }
                }
              } catch (error) {
              }
              window.open(_href, "_self");
            }
          }
        } catch (error) {
          console.dir(error);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error((_d = error.response.data.errors) == null ? void 0 : _d.datas[0].message);
        }
      } finally {
        this.codeFormController.complete();
      }
    });
  }
  createFilter(queryString) {
    return (account) => {
      return account.account.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    };
  }
  querySearch(queryString, cb) {
    this.authFormController.password = "";
    let accounts = null;
    if (this.account_mode === "autocomplete") {
      accounts = queryString ? this.account.filter(this.createFilter(queryString)) : this.account;
    } else {
      accounts = this.account;
    }
    cb(accounts);
  }
  querySearchSubAccount(queryString, cb) {
    this.subAccountauthFormController.password = "";
    let accounts = null;
    if (this.sub_account_mode === "autocomplete") {
      accounts = queryString ? this.sub_account.filter(this.createFilter(queryString)) : this.sub_account;
    } else {
      accounts = this.sub_account;
    }
    cb(accounts);
  }
  useAccount(value) {
    this.authFormController.auth_id = value.account;
    this.authFormController.password = value.password;
    this.remember = value.remember;
  }
  useSubAccount(value) {
    this.subAccountauthFormController.auth_id = value.account;
    this.subAccountauthFormController.password = value.password;
    this.sub_remember = value.remember;
  }
  inputAccount() {
    this.account_mode = "autocomplete";
  }
  inputSubAccount() {
    this.sub_account_mode = "autocomplete";
  }
  focusSubAccount() {
    this._sub_account.focus();
    this.sub_account_mode = "all";
  }
  focusAccount() {
    this._account.focus();
    this.account_mode = "all";
  }
  delAccount(item) {
    return __async(this, null, function* () {
      try {
        yield loginService.removeUsedAccountsFromLocal(item);
        for (let account_index in this.account) {
          let account = this.account[account_index];
          if (account.account === item.account) {
            this.account.splice(account_index, 1);
          }
        }
      } catch (e) {
      }
    });
  }
  delSubAccount(item) {
    return __async(this, null, function* () {
      try {
        console.log(item);
        yield loginService.removeUsedSubAccountsFromLocal(item);
        for (let account_index in this.sub_account) {
          let account = this.sub_account[account_index];
          if (account.account === item.account) {
            this.sub_account.splice(account_index, 1);
          }
        }
      } catch (e) {
      }
    });
  }
  saveAccount(account, password) {
    return __async(this, null, function* () {
      try {
        loginService.savePwdToLocal({
          account,
          password,
          remember: this.remember,
          sort: +new Date()
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  saveSubAccount(account, password) {
    return __async(this, null, function* () {
      try {
        loginService.saveSubPwdToLocal({
          account,
          password,
          remember: this.sub_remember,
          sort: +new Date()
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  getLoginTab() {
    return __async(this, null, function* () {
      try {
        let tabData = yield loginService.getLastLoginTab();
        this.accountTitle = tabData;
      } catch (error) {
        console.log(error);
      }
    });
  }
  saveLoginTab() {
    return __async(this, null, function* () {
      try {
        yield loginService.saveLastLoginTab(this.accountTitle);
      } catch (error) {
        console.log(error);
      }
    });
  }
  forgetPassword() {
    this.$emit("forgetPassword");
  }
  onLoad() {
    console.log("loaded");
  }
  onError() {
    console.log("error");
  }
};
__decorateClass([
  Ref("auth-pin")
], PhoneLogin.prototype, "_auth_pin", 2);
__decorateClass([
  Ref("account-device")
], PhoneLogin.prototype, "_account_device", 2);
__decorateClass([
  Ref("account")
], PhoneLogin.prototype, "_account", 2);
__decorateClass([
  Ref("subaccount")
], PhoneLogin.prototype, "_sub_account", 2);
__decorateClass([
  PropSync("jump")
], PhoneLogin.prototype, "_jump", 2);
__decorateClass([
  PropSync("refer")
], PhoneLogin.prototype, "_refer", 2);
__decorateClass([
  Prop({ default: true })
], PhoneLogin.prototype, "isQrCode", 2);
PhoneLogin = __decorateClass([
  Component({
    components: {
      AccountDevice,
      AuthPinLogin,
      PasswordInput,
      UiForm,
      UiSubmit
    }
  })
], PhoneLogin);
export {
  PhoneLogin as default
};
